import { Empty, Flex, Pagination, Popconfirm, Radio, Select, Spin } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { adminAddCab, adminAddEditCompanyName, adminAddEditModelName, adminDeleteCab, adminDeleteCompanyName, adminDeleteModelName, adminGetAllCabs, adminGetAllModelNames, adminGetCab, adminGetCompanyNames, adminUpdateCab } from "../services/Api";
import { toast, ToastContainer } from "react-toastify";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { countExpiryStatus } from "../services/Function";
const url = process.env.REACT_APP_API_URL
const validationSchema = Yup.object({
    category: Yup.string().required("Category is required"),
    vehicleType: Yup.string().required("Vehicle Type is required"),
    rate_per_km: Yup.object().shape({
        price: Yup.number().required("Price is required").min(0),
        discount: Yup.number().required("Discount is required").min(0),
        after_discount: Yup.number().required("Final Price is required").min(0),
    }),
    extra_fare_per_km: Yup.number().required("Extra fare is required").min(0),
    commission: Yup.number().required("Commission is required").min(0),
    waiting_charge: Yup.number().required("Waiting Charge is required").min(0),
});
const SaveCabs = () => {
    const navigate = useNavigate();
    const [addCabs, setAddCabs] = useState(false)
    const [vehicleData, setVehicleData] = useState({})
    const [isLoading, setIsLoading] = useState(false);
    const [editCab, setEditCab] = useState({})
    const [editCabCompany, setEditCabCompany] = useState({})
    const [cabStatus, setCabStatus] = useState("AllCabs");
    const [cabDetailStatus, setCabDetailStatus] = useState("CabCompany");
    const [cabCompany, setCabCompany] = useState('');
    const [addCompanyName, setAddCompanyName] = useState(false);
    const [addModelName, setAddModelName] = useState(false);
    const [cabCompanyData, setCabCompanyData] = useState([]);
    const [cabModelData, setCabModelData] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [searchValueCompany, setSearchValueCompany] = useState('');
    const [cabModel, setCabModel] = useState('');
    const [editCabModel, setEditCabModel] = useState({})
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [currentPageCompany, setCurrentPageCompany] = useState(1);
    const [totalCompany, setTotalCompany] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageSizeCompany, setPageSizeCompany] = useState(10);
    const [totalCabs, setTotalCabs] = useState(0);
    const [pageSizeCabs, setPageSizeCabs] = useState(10);
    const [currentPageCabs, setCurrentPageCabs] = useState(1);
    const [filterType, setFilterType] = useState("");
    const [rcNumber, setRcNumber] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [fullName, setFullName] = useState("");
    const [ownerName, setOwnerName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [allCabData, setAllCabData] = useState([]);

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }
    const handlePageChangeCompany = (page) => {
        setCurrentPageCompany(page)
    }
    const handlePageChangeCabs = (page) => {
        setCurrentPageCabs(page)
    }
    const handleGetCab = () => {
        setIsLoading(true)
        adminGetCab()
            .then((res) => {
                setIsLoading(false)
                setVehicleData(res?.data?.data.reverse())
            })
            .catch((err) => {
                setIsLoading(false)
            })
    }

    const handleGetAllCabs = () => {
        setIsLoading(true)
        adminGetAllCabs(phoneNumber, firstName, lastName, fullName, ownerName, rcNumber, currentPageCabs, pageSizeCabs, null)
            .then((res) => {
                console.log(res?.data);
                setIsLoading(false)
                setAllCabData(res?.data?.data.reverse())
                setTotalCabs(res?.data?.total)
                setCurrentPageCabs(res?.data?.page)
            })
            .catch((err) => {
                setIsLoading(false)
            })
    }

    useEffect(() => {
        handleGetAllCabs()
    }, [filterType, phoneNumber, firstName, lastName, fullName, ownerName, rcNumber, currentPageCabs, pageSizeCabs]);

    useEffect(() => {
        handleGetCab()
    }, []);
    useEffect(() => {
        handleGetAllModelNames()
    }, [currentPage, pageSize, searchValue]);
    useEffect(() => {
        handleGetCompanyNames()
    }, [currentPageCompany, pageSizeCompany, searchValueCompany]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            category: editCab?.category || "Comfort",
            vehicleType: editCab?.vehicleType || "",
            rate_per_km: {
                price: editCab?.rate_per_km?.price || "",
                discount: editCab?.rate_per_km?.discount || 0,
                after_discount: editCab?.rate_per_km?.after_discount || "",
            },
            extra_fare_per_km: editCab?.extra_fare_per_km || "",
            commission: editCab?.commission || "",
            waiting_charge: editCab?.waiting_charge || "",
        },
        validationSchema,
        onSubmit: values => {
            if (Object.keys(editCab).length > 0) {
                adminUpdateCab(editCab?._id, values)
                    .then((res) => {
                        toast(res.data.message)
                        formik.resetForm();
                        setAddCabs(false);
                        handleGetCab()
                    })
                    .catch((err) => {
                        toast(err.response.data.message)
                    })
            } else {
                adminAddCab(values)
                    .then((res) => {
                        console.log(res.data.message)
                        toast(res.data.message)
                        formik.resetForm();
                        setAddCabs(false);
                        handleGetCab()
                    })
                    .catch((err) => {
                        toast(err?.response?.data?.message)
                    })
            }
        },
    });

    useEffect(() => {
        const price = formik.values.rate_per_km.price || 0;
        const discount = formik.values.rate_per_km.discount || 0;
        const afterDiscount = (price - (price * discount) / 100);

        formik.setFieldValue("rate_per_km.after_discount", afterDiscount);
    }, [formik?.values?.rate_per_km?.price, formik?.values?.rate_per_km?.discount]);

    const vehicleOptions = [
        'Hatchback Car', 'Ecco Car', 'Sedan Car', 'SUV Ertiga Car', 'SUV Innova Car',
        'SUV Crysta Car', 'Tempo Traveller', 'Urbania', 'Small Coach', 'Luxury Coach',
        'Premium Car', 'Parcel', 'Driver', 'Ambulance', 'Loading Auto & Truck',
        'Mini', 'Prime Sedan', 'Prime SUV'
    ].map(item => ({
        value: item,
        label: item
    }));

    const handleDeletCab = (id) => {
        adminDeleteCab(id)
            .then((res) => {
                handleGetCab()
                toast(res.data.message)
            })
            .catch((err) => {
                toast(err.response.data.message)
            })
    };
    const cancel = e => {
        console.log(e);
    };

    const handleAddCompanyName = () => {
        if (!cabCompany) {
            toast.error("Please enter a company name");
        } else {
            adminAddEditCompanyName(cabCompany, editCabCompany?._id)
                .then((res) => {
                    toast.success(res.data.message);
                    setCabCompany('');
                    setAddCompanyName(false);
                    setEditCabCompany({});
                    handleGetCompanyNames();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                    console.log(err)
                })
        }
    }

    const handleGetCompanyNames = () => {
        adminGetCompanyNames(null, searchValueCompany, currentPageCompany, pageSizeCompany)
            .then((res) => {
                console.log(res.data.data)
                setCabCompanyData(res.data.data);
                setTotalCompany(res.data.total);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleDeleteCompanyName = (id) => {
        adminDeleteCompanyName(id)
            .then((res) => {
                toast.success(res.data.message);
                handleGetCompanyNames();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                console.log(err)
            })
    }

    const handleAddModel = () => {
        if (!cabModel || !selectedCompany) {
            toast.error("Please select a company and enter a model name");
        } else {
            const body = {
                companyname: selectedCompany,
                name: cabModel,
                _id: editCabModel?._id || '',
            };
            adminAddEditModelName(body)
                .then((res) => {
                    toast.success(res.data.message);
                    setCabModel('');
                    setSelectedCompany('');
                    setAddModelName(false);
                    handleGetAllModelNames();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                    console.log(err)
                })
        }
    }

    const handleGetAllModelNames = (companyname_id) => {
        adminGetAllModelNames(companyname_id, null, searchValue, currentPage, pageSize)
            .then((res) => {
                console.log(res.data.data)
                setCabModelData(res.data.data);
                setTotal(res.data.total);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleDeleteModelName = (id) => {
        try {
            adminDeleteModelName(id)
                .then((res) => {
                    toast.success(res.data.message);
                    handleGetAllModelNames();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                    console.log(err)
                })
        } catch (error) {
            console.error("Error deleting model name:", error);
        }
    }

    return (
        <>
            <ToastContainer />
            <div className="space-y-6 px-5 py-5">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight text-[#3A4352]">Dashboard</h1>
                    <div className="text-xs sm:text-sm text-muted-foreground">
                        {cabStatus === "CabData" ?
                            <span className='font-semibold text-[#3A4352]'>Cab Management</span>
                            :
                            cabStatus === "AllCabs" ?
                                <span className='font-semibold text-[#3A4352]'>All Cabs</span>
                                :
                                <span className='font-semibold text-[#3A4352]'>Cab Company&Modal</span>

                        }
                    </div>
                </div>
                <div className="block sm:flex bg-[#FFF8E2]">
                    <nav className="flex gap-4" aria-label="Tabs">
                        <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${cabStatus === "AllCabs" ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => setCabStatus("AllCabs")}> All Cabs </button>
                        <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${cabStatus === "CabData" ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => setCabStatus("CabData")}> Cab Management </button>
                        <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${cabStatus === "CabC&M" ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => setCabStatus("CabC&M")}> Cab Company&Modal </button>
                    </nav>
                    {cabStatus === "CabC&M" &&
                        <nav className="flex gap-4 ms-auto border-b-2 sm:border-b-0 pb-3 sm:pb-0" aria-label="Tabs">
                            <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${cabDetailStatus === "CabCompany" ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => setCabDetailStatus("CabCompany")}>
                                CabCompany
                            </button>
                            <button className={`px-3 py-2 text-xs sm:text-sm font-medium text-[#828282] ${cabDetailStatus === "CabModel" ? 'border-b-2 border-[#E53935] text-[#E53935] font-bold' : ''}`} onClick={() => setCabDetailStatus("CabModel")}>
                                CabModel
                            </button>
                        </nav>
                    }
                </div>

                {cabStatus === "AllCabs" && (
                    <>
                        <div className="relative flex justify-end items-center gap-3 w-full mt-5 sm:mt-0">
                            <select
                                className="w-60 h-10 px-2 text-black bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none cursor-pointer"
                                value={filterType}
                                onChange={(e) => { setFilterType(e.target.value); setPhoneNumber(''); setFirstName(''); setLastName(''); setFullName(''); setRcNumber(''); setOwnerName(''); setCurrentPage(1) }}
                            >
                                <option value="" disabled>Filter By</option>
                                <option value="phoneNumber">Phone Number</option>
                                {/* <option value="firstName">First Name</option>
                                <option value="lastName">Last Name</option> */}
                                <option value="fullName">Full Name</option>
                                <option value="rc_number">RC Number</option>
                                <option value="owner_name">Owner Name</option>
                            </select>
                            {filterType && (
                                <input
                                    className="px-3 h-10 rounded-md bg-white border border-gray-300 outline-none"
                                    placeholder={filterType === "rc_number" ? "AB01CD2345" : "Search"}
                                    type={filterType === "phoneNumber" ? "number" : "text"}
                                    value={filterType === "phoneNumber" ? phoneNumber : filterType === "rc_number" ? rcNumber : filterType === "fullName" ? fullName : filterType === "firstName" ? firstName : filterType === "lastName" ? lastName : filterType === "owner_name" ? ownerName : ''}
                                    maxLength={filterType === "phoneNumber" ? 10 : filterType === "rc_number" ? 10 : undefined}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (filterType === "rc_number") {
                                            value = value.toUpperCase();
                                            value = value.replace(/[^A-Z0-9]/g, "");
                                            setRcNumber(value);
                                        }
                                        if (filterType === "phoneNumber") {
                                            value = value.replace(/\D/g, "");
                                            value = value.slice(0, 10);
                                            setPhoneNumber(value);
                                        }
                                        if (filterType === "fullName") {
                                            value = value.replace(/[^a-zA-Z\s]/g, "");
                                            setFullName(value);
                                        }
                                        if (filterType === "firstName") {
                                            value = value.replace(/[^a-zA-Z\s]/g, "");
                                            setFirstName(value);
                                        }
                                        if (filterType === "lastName") {
                                            value = value.replace(/[^a-zA-Z\s]/g, "");
                                            setLastName(value);
                                        }
                                        if (filterType === "owner_name") {
                                            value = value.replace(/[^a-zA-Z\s]/g, "");
                                            setOwnerName(value);
                                        }
                                        setCurrentPage(1);
                                    }}
                                />
                            )}
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8">
                            {allCabData.length > 0 ? (
                                allCabData.map((cab) => (
                                    <div className="bg-white rounded-lg shadow-md overflow-hidden border hover:shadow-lg transition-all duration-300 cursor-pointer" key={cab._id} onClick={() => navigate(`/admin/cab-details`, { state: { cabId: cab._id } })}>
                                        <div className="flex ">
                                            <img
                                                src={cab.vehicle_img ? `${url}${cab.vehicle_img}` : "/placeholder.png"}
                                                alt={cab.cab_number}
                                                className=" w-[30%] h-40 object-cover"
                                            />
                                            <div className="px-4  w-[70%]">
                                                <p className="text-base text-gray-600 mb-1">
                                                    <span className="font-bold ">RC Number:</span> {cab.additional_details?.rc_number}
                                                </p>
                                                <p className="text-sm text-gray-600 mb-1">
                                                    <span className="font-semibold">Type:</span> {cab.vehicleType?.vehicleType}
                                                </p>
                                                <p className="text-sm text-gray-600 mb-1">
                                                    <span className="font-semibold">Category:</span> {cab.vehicleType?.category}
                                                </p>
                                                <p className="text-sm text-gray-600 mb-1">
                                                    <span className="font-semibold">Owner:</span> {cab.additional_details?.owner_name}
                                                </p>
                                                <p className="text-sm text-gray-600 mb-1">
                                                    <span className="font-semibold">Phone:</span> {cab.user_info?.phoneNumber}
                                                </p>
                                                <p className="text-xs text-gray-400 mt-2">
                                                    Registered at: {cab.additional_details?.registered_at}
                                                </p>
                                            </div>
                                        </div>
                                        {(countExpiryStatus(cab.expiry_alerts).expiringSoonCount > 0 || countExpiryStatus(cab.expiry_alerts).expiredCount > 0) && (
                                            <div className="px-4 py-3 bg-red-100 flex gap-3 items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="red" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                                                </svg>
                                                <div className=" flex justify-between gap-3 items-center">
                                                    {countExpiryStatus(cab.expiry_alerts).expiringSoonCount > 0 && (
                                                        <p className="text-sm font-semibold text-red-600">
                                                            Expiring Soon: {countExpiryStatus(cab.expiry_alerts).expiringSoonCount} Certificates
                                                        </p>
                                                    )}
                                                    {countExpiryStatus(cab.expiry_alerts).expiredCount > 0 && (
                                                        <p className="text-sm font-semibold text-red-600">
                                                            Expired: {countExpiryStatus(cab.expiry_alerts).expiredCount} Certificates
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <div className="col-span-full text-center text-gray-500 font-semibold">No cabs found.</div>
                            )}
                        </div>
                        <Pagination
                            align="end"
                            className="my-5"
                            defaultCurrent={1}
                            current={currentPageCabs}
                            total={totalCabs}
                            pageSize={pageSizeCabs}
                            onChange={handlePageChangeCabs}
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={(page, size) => {
                                setPageSizeCabs(size);
                                setCurrentPageCabs(1);
                            }}
                        />
                    </>
                )}

                {cabStatus === "CabData" && (
                    <>
                        <div className="space-y-1 flex justify-end">
                            {!addCabs &&
                                <div className="">
                                    <button size="sm" className="bg-[#1BBD2A] hover:bg-green-600 text-white py-1 px-2 rounded-md active:scale-95 duration-500" onClick={() => setAddCabs(true)}> Add Cab </button>
                                </div>
                            }
                        </div>
                        {addCabs &&
                            <form onSubmit={formik.handleSubmit}>
                                <div className="p-5">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                        <div className=" flex items-center gap-5">
                                            <label className=" font-semibold w-[30%]"> Category</label>
                                            <Radio.Group
                                                className="w-[70%]"
                                                name="category"
                                                value={formik.values.category}
                                                onChange={(e) => formik.setFieldValue("category", e.target.value)}
                                                defaultValue={"Comfort"}
                                                options={[
                                                    { value: "Comfort", label: 'Comfort' },
                                                    { value: "Premium", label: 'Premium' },
                                                ]}
                                            />
                                        </div>
                                        <div>
                                            <div className=" flex items-center gap-5">
                                                <label className=" font-semibold w-[30%]"> Vehicle Type</label>
                                                {/* <Select
                                                mode="tags"
                                                placeholder='Select Vehicle Type'
                                                className="w-[70%] outline-none !h-8 !text-black"
                                                disabled={editCab?.vehicleType}
                                                value={formik.values.vehicleType}
                                                onChange={(value) => formik.setFieldValue("vehicleType", value)}
                                                options={vehicleOptions}
                                            /> */}

                                                <Select
                                                    mode="tags"
                                                    placeholder="Select Vehicle Type"
                                                    className="w-[70%] outline-none !h-8 !text-black"
                                                    disabled={editCab?.vehicleType}
                                                    value={formik.values.vehicleType ? [formik.values.vehicleType] : []} // convert string to array for Select
                                                    onChange={(value) => {
                                                        const selected = value[0] || ""; // allow only 1 tag
                                                        formik.setFieldValue("vehicleType", selected); // store as string in Formik
                                                    }}
                                                    maxTagCount={1} // just in case
                                                    options={vehicleOptions}
                                                />


                                            </div>
                                            {formik.touched.vehicleType && formik.errors.vehicleType && (
                                                <p className="text-red-500 text-xs flex flex-col">{formik.errors.vehicleType}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className=" my-5">
                                        <label className=" font-semibold text-lg"> Rate Per Km.</label>
                                        <div className="grid grid-cols-1 md:grid-cols-3 mt-1 gap-5">
                                            <div className=" flex flex-col">
                                                <label className=" text-sm font-semibold mb-2"> Price</label>
                                                {/* <input after_discountclassName="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none border border-gray-300 rounded-lg h-8 ps-2" placeholder="Enter Price " min={0} type="number" /> */}
                                                <input
                                                    type="number"
                                                    min={0}
                                                    name={`rate_per_km.price`}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.rate_per_km.price}
                                                    className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none border border-gray-300 rounded-lg h-8 ps-2"
                                                    placeholder={`Enter price`}
                                                />
                                                {formik.touched.rate_per_km?.price && formik.errors.rate_per_km?.price && (
                                                    <span className="text-red-500 text-xs">{formik.errors.rate_per_km.price}</span>
                                                )}
                                            </div>
                                            <div className=" flex flex-col">
                                                <label className=" text-sm font-semibold mb-2 "> Discount</label>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    name={`rate_per_km.discount`}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.rate_per_km.discount}
                                                    className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none border border-gray-300 rounded-lg h-8 ps-2"
                                                    placeholder={`Enter Discount`}
                                                />
                                                {formik.touched.rate_per_km?.discount && formik.errors.rate_per_km?.discount && (
                                                    <span className="text-red-500 text-xs">{formik.errors.rate_per_km.discount}</span>
                                                )}
                                            </div>
                                            <div className=" flex flex-col">
                                                <label className=" text-sm font-semibold mb-2 "> After Discount</label>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    step="0.01"
                                                    name={`rate_per_km.after_discount`}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.rate_per_km.after_discount}
                                                    className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none border border-gray-300 rounded-lg h-8 ps-2"
                                                    placeholder={`Enter After Discount`}
                                                />
                                                {formik.touched.rate_per_km?.after_discount && formik.errors.rate_per_km?.after_discount && (
                                                    <span className="text-red-500 text-xs">{formik.errors.rate_per_km.after_discount}</span>
                                                )}
                                            </div>
                                            <div className=" flex flex-col">
                                                <label className=" text-sm font-semibold mb-2 "> Extra Fare Per Km.</label>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    name={`extra_fare_per_km`}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.extra_fare_per_km}
                                                    className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none border border-gray-300 rounded-lg h-8 ps-2"
                                                    placeholder={`Enter Extra Fare Per km`}
                                                />
                                                {formik.touched.extra_fare_per_km && formik.errors.extra_fare_per_km && (
                                                    <span className="text-red-500 text-xs">{formik.errors.extra_fare_per_km}</span>
                                                )}
                                            </div>
                                            <div className=" flex flex-col">
                                                <label className=" text-sm font-semibold mb-2 "> Commission</label>
                                                <input
                                                    type="number"
                                                    min={1}
                                                    name={`commission`}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.commission}
                                                    className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none border border-gray-300 rounded-lg h-8 ps-2"
                                                    placeholder={`Enter Commission`}
                                                />
                                                {formik.touched.commission && formik.errors.commission && (
                                                    <span className="text-red-500 text-xs">{formik.errors.commission}</span>
                                                )}
                                            </div>
                                            <div className=" flex flex-col">
                                                <label className=" text-sm font-semibold mb-2 "> Waiting Charge </label>
                                                <input
                                                    type="number"
                                                    min={1}
                                                    name={`waiting_charge`}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.waiting_charge}
                                                    className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none border border-gray-300 rounded-lg h-8 ps-2"
                                                    placeholder={`Enter Waiting Charge`}
                                                />
                                                {formik.touched.waiting_charge && formik.errors.waiting_charge && (
                                                    <span className="text-red-500 text-xs">{formik.errors.waiting_charge}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className=" flex justify-end mt-5 gap-5">
                                            <button type="button" size="sm" className=" text-gray-500 border border-gray-400 py-1 px-2 rounded-md active:scale-95 duration-500" onClick={() => { setEditCab({}); setAddCabs(false) }}> Cancel </button>
                                            <button type="submit" size="sm" className="bg-[#1BBD2A] hover:bg-green-600 text-white py-1 px-2 rounded-md active:scale-95 duration-500"> {Object.keys(editCab).length > 0 ? "Update Cab" : "Save Cab"} </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        }
                        {isLoading ?
                            <div className='mt-20 flex justify-center items-center'>
                                <Flex gap="middle" vertical>
                                    <Spin tip="Loading" size="large">
                                        <div className='p-12 rounded-xl'></div>
                                    </Spin>
                                </Flex>
                            </div>
                            : (
                                vehicleData.length > 0 ?
                                    (<>
                                        <div className="border rounded-lg overflow-x-auto ">
                                            <table className="w-full">
                                                <thead>
                                                    <tr className=" bg-muted/50 bg-[#FFF0F2] ">
                                                        <th className=" min-min-w-[70px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2 rounded-s-lg">Vehicle</th>
                                                        <th className=" min-min-w-[100px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Category</th>
                                                        <th className=" min-min-w-[120px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Rate /Km</th>
                                                        <th className=" min-min-w-[120px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Discount</th>
                                                        <th className=" min-min-w-[120px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Extra Fare /Km</th>
                                                        <th className=" min-min-w-[120px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Update</th>
                                                        <th className=" min-min-w-[100px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold rounded-e-lg">Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {vehicleData.map((vehicle, index) => (
                                                        <tr key={index} className="border-b last:border-0">
                                                            <td className=" min-w-[70px] py-3 px-4 text-xs sm:text-sm text-[#62ABF4] text-center" >{vehicle?.vehicleType}</td>
                                                            <td className=" min-w-[100px] py-3 px-4 text-xs sm:text-sm text-[#394253] text-center" >{vehicle?.category}</td>
                                                            <td className=" min-w-[120px] py-3 text-center text-[#394253] text-xs sm:text-sm" >
                                                                {vehicle?.rate_per_km?.price}
                                                            </td>
                                                            <td className=" min-w-[120px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] ">
                                                                {vehicle?.rate_per_km?.discount} %
                                                            </td>
                                                            <td className=" min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] ">
                                                                {vehicle?.extra_fare_per_km}
                                                            </td>
                                                            <td className=" min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] " onClick={() => { setEditCab(vehicle); setAddCabs(true); window.scroll(0, 0) }}>
                                                                <PencilSquareIcon className="size-7 text-blue-500 mx-auto cursor-pointer active:scale-95 duration-500" />
                                                            </td>
                                                            <td className=" min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] ">
                                                                <Popconfirm
                                                                    title="Delete"
                                                                    description="Are you sure to delete this Cab?"
                                                                    onConfirm={() => handleDeletCab(vehicle?._id)}
                                                                    onCancel={cancel}
                                                                    okText="Yes"
                                                                    cancelText="No"
                                                                >
                                                                    <TrashIcon className="size-7 text-red-500 mx-auto cursor-pointer active:scale-95 duration-500" />
                                                                </Popconfirm>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>) : (<Empty />)
                            )
                        }
                    </>
                )}
                {cabStatus === "CabC&M" && (
                    <>
                        <div className="">
                            <div className="w-full flex justify-end items-center my-5">
                                <div className="flex items-center gap-2">
                                    {cabDetailStatus === "CabCompany" && (
                                        <>
                                            <input type="text" placeholder="Search..." className="px-3 py-1 rounded-md bg-[#F0F0F0] outline-none" onChange={(e) => setSearchValueCompany(e.target.value)} />
                                            <button size="sm" className="bg-[#1BBD2A] hover:bg-green-600 text-white py-1 px-2 rounded-md active:scale-95 duration-500" onClick={() => setAddCompanyName(true)}> Add Company </button>
                                        </>
                                    )}
                                    {cabDetailStatus === "CabModel" && (
                                        <>
                                            <input type="text" placeholder="Search..." className="px-3 py-1 rounded-md bg-[#F0F0F0] outline-none" onChange={(e) => setSearchValue(e.target.value)} />
                                            <button size="sm" className="bg-[#1BBD2A] hover:bg-green-600 text-white py-1 px-2 rounded-md active:scale-95 duration-500" onClick={() => setAddModelName(true)}> Add Model </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        {cabDetailStatus === "CabCompany" && (
                            <div>
                                {addCompanyName && (
                                    <>
                                        <div className="w-full md:w-1/2 mx-auto my-5">
                                            <label className="text-sm text-gray-400 font-semibold mb-2">Company Name</label>
                                            <input
                                                className="mt-2 px-3 py-2 w-full rounded-md bg-[#F0F0F0] outline-none"
                                                placeholder="Enter cab company here..."
                                                value={cabCompany}
                                                onChange={(e) => setCabCompany(e.target.value)}
                                            />
                                            <div className="flex justify-end mt-5 gap-5">
                                                <button type="button" className="text-gray-400 border border-gray-400 bg-white py-1 px-2 rounded-md active:scale-95 duration-500" onClick={() => { setAddCompanyName(false); setCabCompany(''); setEditCabCompany({}); }}> Cancel </button>
                                                <button type="button" className="text-white bg-[#1BBD2A] py-1 px-2 rounded-md active:scale-95 duration-500" onClick={handleAddCompanyName}> {editCabCompany?.name ? "Update" : "Add"} </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {isLoading ?
                                    <div className='mt-20 flex justify-center items-center'>
                                        <Flex gap="middle" vertical>
                                            <Spin tip="Loading" size="large">
                                                <div className='p-12 rounded-xl'></div>
                                            </Spin>
                                        </Flex>
                                    </div>
                                    : (
                                        cabCompanyData.length > 0 ?
                                            (<>
                                                <div className="border rounded-lg overflow-x-auto ">
                                                    <table className="w-full">
                                                        <thead>
                                                            <tr className=" bg-muted/50 bg-[#FFF0F2] ">
                                                                <th className=" min-min-w-[70px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2 rounded-s-lg">Company Name</th>
                                                                <th className=" min-min-w-[120px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Update</th>
                                                                <th className=" min-min-w-[100px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold rounded-e-lg">Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {cabCompanyData.map((vehicle, index) => (
                                                                <tr key={index} className="border-b last:border-0">
                                                                    <td className=" min-w-[70px] py-3 px-4 text-xs sm:text-sm text-[#62ABF4] text-center" >{vehicle?.name}</td>
                                                                    <td className=" min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] " onClick={() => { setEditCabCompany(vehicle); setCabCompany(vehicle?.name); setAddCompanyName(true); window.scroll(0, 0) }}>
                                                                        <PencilSquareIcon className="size-7 text-blue-500 mx-auto cursor-pointer active:scale-95 duration-500" />
                                                                    </td>
                                                                    <td className=" min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] ">
                                                                        <Popconfirm
                                                                            title="Delete"
                                                                            description="Are you sure to delete this Cab?"
                                                                            onConfirm={() => handleDeleteCompanyName(vehicle?._id)}
                                                                            onCancel={cancel}
                                                                            okText="Yes"
                                                                            cancelText="No"
                                                                        >
                                                                            <TrashIcon className="size-7 text-red-500 mx-auto cursor-pointer active:scale-95 duration-500" />
                                                                        </Popconfirm>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <Pagination
                                                    align="end"
                                                    className="my-5"
                                                    defaultCurrent={1}
                                                    current={currentPageCompany}
                                                    total={totalCompany}
                                                    pageSize={pageSizeCompany}
                                                    onChange={handlePageChangeCompany}
                                                    showSizeChanger
                                                    pageSizeOptions={['10', '20', '50', '100']}
                                                    onShowSizeChange={(page, size) => {
                                                        setPageSizeCompany(size);
                                                        setCurrentPageCompany(1);
                                                    }}
                                                />
                                            </>) : (<Empty />)
                                    )
                                }
                            </div>
                        )}
                        {cabDetailStatus === "CabModel" && (
                            <div>
                                {addModelName && (
                                    <>
                                        <div className="w-full mx-auto my-5">
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                                <div className=" flex flex-col">
                                                    <label className="text-sm text-gray-400 font-semibold mb-2">Company Name</label>
                                                    <Select
                                                        placeholder="Select Vehicle Type"
                                                        className="w-[90%] outline-none !h-8 !text-black"
                                                        value={selectedCompany}
                                                        onChange={(value) => {
                                                            setSelectedCompany(value);
                                                        }}
                                                        options={cabCompanyData.map(item => ({
                                                            label: item.name,
                                                            value: item._id
                                                        }))}
                                                    />
                                                </div>
                                                <div className=" flex flex-col">
                                                    <label className="text-sm text-gray-400 font-semibold mb-2">Model Name</label>
                                                    <input
                                                        className=" px-3 py-1 w-[90%] rounded-md bg-[#F0F0F0] outline-none"
                                                        placeholder="Enter cab company here..."
                                                        value={cabModel}
                                                        onChange={(e) => setCabModel(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex justify-end mt-5 gap-5">
                                                <button type="button" className="text-gray-400 border border-gray-400 bg-white py-1 px-2 rounded-md active:scale-95 duration-500" onClick={() => { setEditCabModel({}); setSelectedCompany(''); setCabModel(""); setAddModelName(false); }}> Cancel </button>
                                                <button type="button" className="text-white bg-[#1BBD2A] py-1 px-2 rounded-md active:scale-95 duration-500" onClick={handleAddModel}> {editCabModel?.name ? "Update" : "Add"} </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {isLoading ?
                                    <div className='mt-20 flex justify-center items-center'>
                                        <Flex gap="middle" vertical>
                                            <Spin tip="Loading" size="large">
                                                <div className='p-12 rounded-xl'></div>
                                            </Spin>
                                        </Flex>
                                    </div>
                                    : (
                                        cabModelData.length > 0 ?
                                            (<>
                                                <div className="border rounded-lg overflow-x-auto ">
                                                    <table className="w-full">
                                                        <thead>
                                                            <tr className=" bg-muted/50 bg-[#FFF0F2] ">
                                                                <th className=" min-min-w-[70px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2 rounded-s-lg">Company Name</th>
                                                                <th className=" min-min-w-[120px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Model Name</th>
                                                                <th className=" min-min-w-[120px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold border-r-2">Update</th>
                                                                <th className=" min-min-w-[100px] text-center text-[#394253] py-3 px-4 text-xs sm:text-sm font-semibold rounded-e-lg">Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {cabModelData.map((vehicle, index) => (
                                                                <tr key={index} className="border-b last:border-0">
                                                                    <td className=" min-w-[70px] py-3 px-4 text-xs sm:text-sm text-[#62ABF4] text-center" >{vehicle?.companyname?.name}</td>
                                                                    <td className=" min-w-[70px] py-3 px-4 text-xs sm:text-sm text-[#62ABF4] text-center" >{vehicle?.name}</td>
                                                                    <td className=" min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] " onClick={() => { setEditCabModel(vehicle); setSelectedCompany(vehicle?.companyname?._id); setCabModel(vehicle?.name); setAddModelName(true); window.scroll(0, 0) }}>
                                                                        <PencilSquareIcon className="size-7 text-blue-500 mx-auto cursor-pointer active:scale-95 duration-500" />
                                                                    </td>
                                                                    <td className=" min-w-[100px] py-3 px-4 text-xs sm:text-sm text-center text-[#394253] ">
                                                                        <Popconfirm
                                                                            title="Delete"
                                                                            description="Are you sure to delete this Cab?"
                                                                            onConfirm={() => handleDeleteModelName(vehicle?._id)}
                                                                            onCancel={cancel}
                                                                            okText="Yes"
                                                                            cancelText="No"
                                                                        >
                                                                            <TrashIcon className="size-7 text-red-500 mx-auto cursor-pointer active:scale-95 duration-500" />
                                                                        </Popconfirm>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <Pagination
                                                    align="end"
                                                    current={currentPage}
                                                    total={total}
                                                    pageSize={pageSize}
                                                    defaultCurrent={1}
                                                    showSizeChanger
                                                    pageSizeOptions={['10', '20', '50', '100']}
                                                    onChange={handlePageChange}
                                                    onShowSizeChange={(page, size) => {
                                                        setPageSize(size);
                                                        setCurrentPage(1);
                                                    }}
                                                />
                                            </>) : (<Empty />)
                                    )
                                }
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    )
}
export default SaveCabs;